import React from 'react';
import { sectionIcons, type SectionIconName } from '../icons/registry';

interface SectionIconProps {
  /** Registered icon key (see icons/registry.ts). */
  name: SectionIconName;
  /** Diameter in pixels. Section-header default is 28. */
  size?: number;
  /** Override the default secondary-color accent. */
  color?: string;
}

export const SectionIcon: React.FC<SectionIconProps> = ({
  name,
  size = 28,
  color = 'var(--secondary-color, #F51C17)',
}) => {
  const Icon = sectionIcons[name];
  return <Icon size={size} weight="duotone" color={color} />;
};

export default SectionIcon;
